export type Transform = { scale: number; x: number; y: number };

export const MIN_SCALE = 1;
export const MAX_SCALE = 4;

export const clamp = (value: number, min: number, max: number): number =>
  Math.max(min, Math.min(max, value));

export const clampTransform = (t: Transform, width: number, height: number): Transform => {
  const scale = clamp(t.scale, MIN_SCALE, MAX_SCALE);
  return {
    scale,
    x: clamp(t.x, width - width * scale, 0),
    y: clamp(t.y, height - height * scale, 0),
  };
};

export const zoomAtPoint = (
  prev: Transform,
  nextScale: number,
  cx: number,
  cy: number,
  width: number,
  height: number,
): Transform => {
  const scale = clamp(nextScale, MIN_SCALE, MAX_SCALE);
  const k = scale / prev.scale;
  return clampTransform({ scale, x: cx - (cx - prev.x) * k, y: cy - (cy - prev.y) * k }, width, height);
};
